export const es = { 
  // Header/Sidebar
  user: 'Usuario',
  users: 'Usuarios',
  installations: 'Instalaciones',
  settings: 'Configuraciones',
  certificate: 'Certificado',
  main_settings: 'Configuración principal',
  terminology: 'Terminología',
  equipment: 'Equipo',
  security: 'Seguridad',
  tenants: 'Inquilinos',
  collapse: 'Contraer',
  branding: 'Gestión de marca',
  sign_out: 'Salir',
  hello: '¡Hola!',

  // Misc
  save: 'Guardar',
  cancel: 'Cancelar',

  // Installation Table
  status: 'Estado',
  clear: 'Eliminar',
  date: 'Fecha',
  technician: 'Técnico',
  customer_phone: 'Teléfono del cliente',
  address: 'Dirección',
  unit: 'Unidad',
  city: 'Ciudad',
  state_prov: 'Estado/Prov.',
  rooms_tested: 'Prueba de habitaciones',
  tested: 'Probado',
  plan: 'Plan',
  rows_per_page: 'Filas por página',
  recommended_short: 'Recomm.',
  notes: 'Notas',

  // Certificate Branding Tab
  current_image: 'Imagen actual: ',
  using_default_logo: 'Uso del logotipo predeterminado',
  new_image: 'Nueva imagen',
  branding_loading_error: 'Error de carga de marca. Inténtelo de nuevo más tarde.',
  upload_new_image: 'Subir nueva imagen',
  clear_custom_image: 'Limpiar Imagen personalizada',
  clear_custom_color: 'Borrar color personalizado',
  brand_color: 'Color de marca',
  header_message: 'Mensaje de encabezado',
  header_education_message: 'Mensaje instructivo de encabezado',
  footer_education_message: 'Mensaje instructivo de pie de página',
  preview: 'Vista previa',
  file_must_be_less_than_size_limit: 'El archivo debe ser inferior a 30KB',

  // Certificate Headers
  congrats_message: "Su instalación wifi se ha completado y se ha certificado por RouteThis.",
  installation_details: "Detalles de la instalación",
  wireless_speed_test: "Test de velocidad inalámbrica",
  wireless_performance: "Desempeño inalámbrico",
  photos: "Fotos",
  signal_maps: "Mapas de señal",
  wifi_information: "Información de wifi",

  // Certificate Room Names
  singular_room: "Habitación",
  room_type_bathroom: "Cuarto de baño",
  room_type_bedroom: "Dormitorio",
  room_type_dining_room: "Comedor",
  room_type_entry_or_hall: "Entrada/Salón",
  room_type_garage: "Garaje",
  room_type_kitchen: "Cocina",
  room_type_living_room: "Sala de estar",
  room_type_office: "Oficina",
  room_type_other: "Otros",

  // Pod Name
  pod_1: "Dispositivo",
  pod_2: "Punto de acceso",
  pod_3: "Nodo",
  pod_4: "Módulo",
  pod_5: "Modelo",
  pod_6: "Dispositivo",
  pods_1: "Dispositivos",
  pods_2: "Puntos de acceso ",
  pods_3: "Nodos",
  pods_4: "Módulos",
  pods_5: "Modelos",
  pods_6: "Dispositivos",

  // Router Name
  router_1: "Rúter",
  router_2: "Módem",
  router_3: "Puerta de acceso",
  router_4: "Intercambiador de datos",
  router_5: "Rúter",

  // Level Name
  level_1: "Nivel",
  level_2: "Piso",
  levels_1: "Niveles",
  levels_2: "Pisos",

  // Certificate Pod Info
  recommended: "Recomendado",
  installed: "Instalado",
  total: "Total",

  // Certificate Signal Table
  front_building: "Frente del edificio",
  speed: "Veloc.",
  video: "Vídeo",
  rssi: "RSSI",
  rssi_description: "dBm",
  link: "Enlace",
  frequency_short: "Frec.",
  frequency_description: "MHz",
  channel_short: "Can.",

  // Certificate Legend
  legend: "Leyenda",
  measured_speed: "Velocidad medida",
  measured_speed_description: "Mbps",

  // Certificate Speedtest Result
  speedtest_passed: "La velocidad está entre los valores esperados para la mayoría de dispositivos móviles. No todos los dispositivos inalámbricos son capaces de alcanzar el máximo de la velocidad contratada. A continuación tiene pruebas individuales de espacios.",
  speedtest_failed: "Probado en móvil o tableta. No todos los dispositivos inalámbricos son capaces de alcanzar el máximo de la velocidad contratada. A continuación tiene pruebas individuales de espacios.",

  // Login/Reset Password
  email: 'Correo electrónico',
  password: 'Contraseña',
  sign_in: 'Acceder',
  forgot_password: 'Olvidé mi contraseña',
  reset_password: 'Restablecer contraseña',
  reset_password_instructions: 'Para restablecer su contraseña, ingrese su dirección de correo electrónico arriba y le enviaremos instrucciones, si la cuenta existe.',
  sent_reset_password_code: 'Hemos enviado un código de restablecimiento de contraseña a [email]. Ingrese dicho código y una nueva contraseña.',
  reset_code: 'Código de restablecimiento',
  new_password: 'Nueva contraseña',
  reenter_new_password: 'Vuelva a ingresar la nueva contraseña',
  must_include_email: 'Debe incluir correo electrónico',
  old_password: 'Contraseña anterior',
  set_new_password: 'Establecer nueva contraseña',
  password_expired: 'La contraseña ha expirado',
  toggle_password_visibility: 'Alternar la visibilidad de la contraseña',
  change_your_password: 'Cambia la contraseña',
  change_password: 'Cambia tu contraseña',
  set_password: 'Configurar la contraseña',

  // Users List
  new_user: 'Nuevo usuario',
  edit_user: 'Editar usuario',
  bulk_import: 'Importación masiva',
  show_disabled_users: 'Mostrar usuarios deshabilitados',
  name: 'Nombre',
  role: 'Rol',

  // Valid User roles
  user_role: 'usuario',
  tenant_admin_role: 'AdminInquilinos',
  super_admin_role: 'SuperAdmin',
  tenant_admin: 'Administrador de inquilinos',
  super_admin: 'Superadministrador',

  // Create/Edit User Modal
  email_required: 'Correo electrónico (obligatorio)',
  first_name: 'Nombre',
  last_name: 'Apellidos',
  force_password_reset: 'Forzar restablecimiento de contraseña',
  resend_validation_code: 'Reenviar código de validación',
  enable_user: 'Habilitar usuario',
  disable_user: 'Deshabilitar usuario',
  certify: 'Certificar',
  unverified: 'No verificado',
  locked_out: 'Bloqueado',
  disabled: 'Deshabilitado',
  reset_user_password_confirmation: '¿Está seguro de que desea restablecer la contraseña de este usuario?',
  resend_validation_code_confirmation: '¿Está seguro de que desea reenviar el código de validación?',
  cannot_disable_yourself: 'No puede deshabilitarse a sí mismo',
  cancel_changes: 'Cancelar cambios',

  // Bulk Import Modal
  csv_format_requirements: 'Formato de CSV: correo electrónico, nombre, apellidos, rol (solo es obligatorio el correo electrónico)',
  valid_user_roles: 'Roles de usuario válidos: "user", "TenantAdmin", "SuperAdmin"',
  select_csv: 'Seleccionar CSV',
  import: 'Importar',
  file_too_large: 'Archivo demasiado grande (máximo 500 usuarios)',
  required_headers_missing: 'Faltan encabezados obligatorios: correo electrónico',
  user_import_starting: 'Importación de usuarios iniciada. Recibirá un correo electrónico con el resumen de la importación en unos minutos.',

  // Tenant Main Settings
  email_language: 'Idioma de correo electrónico',
  country: 'País',
  description_optional: 'Descripción (opcional)',
  units_feet_meters: 'Unidades (pies, metros)',
  certify_id: 'Certify ID',
  resolve_id: 'Resolve ID',
  sms_settings: 'Configuración de SMS',
  sms_from: 'SMS de',
  sms_body: 'Cuerpo del SMS',
  default_sms_body: '¡Su instalación wifi se ha completado y ha sido certificada por [NAME]! Vea su certificado aquí: [LINK]',
  sms_body_helper_text: 'Al certificar, se enviará este mensaje de texto al cliente. [LINK] se sustituirá por un enlace al certificado (obligatorio). [NAME] se sustituirá por el contenido del campo "Nombre" (opcional)',
  link_must_be_in_sms_body: '[LINK] debe estar en el cuerpo del SMS.',
  update_successful: 'Actualización correcta',
  creation_successful: 'Creación correcta',

  // Tenant Terminology Settings
  term: 'Término',
  example_usage: 'Ejemplo de uso',
  customer_example_usage_1: 'Tras consultar al cliente, confirme el edificio seleccionado o vuelva a editar la dirección.',
  customer_example_usage_2: 'Tras consultar al abonado, confirme el edificio seleccionado o vuelva a editar la dirección.',
  router_example_usage_1: 'Pulse en la ubicación propuesta del enrutador a continuación.',
  router_example_usage_2: 'Pulse en la ubicación propuesta del módem a continuación.',
  router_example_usage_3: 'Pulse en la ubicación propuesta de la puerta de enlace a continuación.',
  router_example_usage_4: 'Pulse en la ubicación propuesta del concentrador a continuación.',
  router_example_usage_5: 'Pulse en la ubicación propuesta del enrutador a continuación.',
  level_example_usage_1: 'Vaya al 2.º nivel y pulse en su ubicación.',
  level_example_usage_2: 'Vaya al 2.º piso y pulse en su ubicación.',
  mesh_pod_example_usage_1: 'Estimación de la intensidad de la señal y ubicación óptima de las cápsulas de malla.',
  mesh_pod_example_usage_2: 'Estimación de la intensidad de la señal y ubicación óptima de los puntos de acceso.',
  mesh_pod_example_usage_3: 'Estimación de la intensidad de la señal y ubicación óptima de los nodos de malla.',
  mesh_pod_example_usage_4: 'Estimación de la intensidad de la señal y ubicación óptima de los discos de malla.',
  mesh_pod_example_usage_5: 'Estimación de la intensidad de la señal y ubicación óptima de las balizas.',
  mesh_pod_example_usage_6: 'Estimación de la intensidad de la señal y ubicación óptima de las cápsulas de malla.',
  wifi_example_usage_1: 'Mapeo WiFi',
  wifi_example_usage_2: 'Mapeo Wi-Fi',
  wifi_example_usage_3: 'Mapeo wifi',
  wifi_example_usage_4: 'Mapeo WIFI',

  // Tenant Equipment Settings (Certify)
  router_options_1: 'Opciones del enrutador',
  router_options_2: 'Opciones del módem',
  router_options_3: 'Opciones de la puerta de enlace',
  router_options_4: 'Opciones del concentrador',
  router_options_5: 'Opciones del enrutador',
  new_router_options_1: 'Nuevas opciones del enrutador',
  new_router_options_2: 'Nuevas opciones de módem',
  new_router_options_3: 'Nuevas opciones de la puerta de enlace',
  new_router_options_4: 'Nuevas opciones del concentrador',
  new_router_options_5: 'Nuevas opciones del enrutador',
  mesh_pod_options_1: 'Opciones de las cápsulas de malla',
  mesh_pod_options_2: 'Opciones de los puntos de acceso',
  mesh_pod_options_3: 'Opciones de los nodos de malla',
  mesh_pod_options_4: 'Opciones de los discos de malla',
  mesh_pod_options_5: 'Opciones de las balizas',
  mesh_pod_options_6: 'Opciones de las cápsulas de malla',
  new_mesh_pod_options_1: 'Nuevas opciones de vainas de malla',
  new_mesh_pod_options_2: 'Nuevas opciones de puntos de acceso',
  new_mesh_pod_options_3: 'Nuevas opciones de nodos de malla',
  new_mesh_pod_options_4: 'Nuevas opciones de discos de malla',
  new_mesh_pod_options_5: 'Nuevas opciones de señalización',
  new_mesh_pod_options_6: 'Nuevas opciones de vainas de malla',
  missing_required_router_info_1: 'Falta la información requerida del router',
  missing_required_router_info_2: 'Falta la información requerida del módem',
  missing_required_router_info_3: 'Falta la información requerida de la puerta de enlace',
  missing_required_router_info_4: 'Falta la información requerida del hub',
  missing_required_router_info_5: 'Falta la información requerida del router',
  missing_required_mesh_pod_info_1: 'Falta la información requerida de la vaina de malla',
  missing_required_mesh_pod_info_2: 'Falta información del punto de acceso requerido',
  missing_required_mesh_pod_info_3: 'Falta información requerida del nodo de malla',
  missing_required_mesh_pod_info_4: 'Falta información sobre el disco de malla requerido',
  missing_required_mesh_pod_info_5: 'Falta la información de la baliza requerida',
  missing_required_mesh_pod_info_6: 'Falta la información requerida de la vaina de malla',
  display_name: 'Alias',
  description: 'Descripción',
  range_in_unit_1: 'Alcance en pies',
  range_in_unit_2: 'Alcance en metros',
  area_in_unit_1: 'Área en Pies Cuadrados',
  area_in_unit_2: 'Área en Metros Cuadrado',
  default_active: 'Activo por defecto',
  average_range: 'Alcance medio',
  certify_default: 'Certificar por defecto',
  default: 'Predeterminado',
  active: 'Activo',
  one_option_must_be_default: 'Una opción debe ser la predeterminada',
  set_as_default: 'Establecer como predeterminado',
  default_option_must_be_active: 'La opción predeterminada debe estar activa',
  deactivate: 'Desactivar',
  activate: 'Activar',
  name_is_required: 'El nombre es obligatorio',

  // Customer Name
  customer_1: 'Cliente',
  customer_2: 'Abonado',

  // Wifi Name
  wifi_1: 'WiFi',
  wifi_2: 'Wi-Fi',
  wifi_3: 'Wifi',
  wifi_4: 'WIFI',

  // Units
  units_1: 'Pies',
  units_2: 'Metros',

  
  // Misc
  confirm: 'Confirmar',
  units: 'Unidades',
  region: 'Región',
  edit: 'Edit',
  modified: 'Modificada',
  create: 'Crear',
  created: 'Creada',
  routethis_app: 'Aplicación RouteThis',
  loading: 'Cargando…',
  redirecting: 'Redirigiendo…',
  error: 'Error',
  close: 'Cerrar',

  // Languages
  en: 'Inglés (Estados Unidos)',
  'en-GB': 'Inglés (Reino Unido)',
  da: 'Danés',
  fi: 'Finlandés',
  fr: 'Francés',
  'fr-CA': 'Francés (Canadá)',
  de: 'Alemán',
  el: 'Griego',
  it: 'Italiano',
  pt: 'Portugués',
  'pt-BR': 'Portugués (Brasil)',
  es: 'Español',
  'es-419': 'Español (Latinoamérica)',
  sv: 'Sueco',
}

export const es_errors = {
  // Client-side validation errors
  incorrect_email_or_password: 'Correo electrónico o contraseña incorrectos, o cuenta desactivada. Inténtelo de nuevo o póngase en contacto con un administrador.',
  invalid_reset_code: 'Código de restablecimiento no válido',
  password_minimum_requirements: 'La contraseña debe tener un mínimo de 8 caracteres e incluir al menos una minúscula, una mayúscula y un número.',
  passwords_must_match: 'Las contraseñas deben coincidir',
  must_include_new_password_email: 'Debe incluir una nueva contraseña y un correo electrónico de usuario',
  must_include_new_password_confirmation_code: 'Debe incluir una nueva contraseña y un código de confirmación',
  cannot_send_reset_code_without_email: 'No se puede enviar el código de restablecimiento sin correo electrónico',
  must_enter_old_password: 'Debes ingresar tu antigua contraseña',
  must_enter_reset_code: 'Debe introducir el código de reinicio',
  must_enter_new_password: 'Debe introducir una nueva contraseña',
  passwords_cannot_begin_or_end_with_spaces: 'Las contraseñas no pueden empezar ni terminar con espacios',

  // Server-side errors
  'User with that email already exists': "El usuario con ese correo electrónico ya existe",
  'Try another display name': "Pruebe con otro nombre de usuario",
  'Password cannot be a previously used password': "La contraseña no puede ser una contraseña utilizada anteriormente",
  'Invalid reset code': "Código de restablecimiento no válido",
  'Wrong username and password combination or the user does not exist.': "Correo electrónico o contraseña incorrectos, o cuenta desactivada. Inténtelo de nuevo o póngase en contacto con un administrador.",
  'Invalid code provided, please request a code again.': 'El código proporcionado es inválido. Solicite un código de nuevo.',
  'Password cannot begin or end with spaces': "Las contraseñas no pueden empezar ni terminar con espacios",
  'LimitExceededException - Attempt limit exceeded, please try after some time.': "Ha excedido el límite de intentos permitidos. Vuelva a intentarlo más tarde.",
  'User is not Authorized': "Usuario no autorizado",
  'Your session timed out. Sign in again with your temporary password.': "Su sesión ha finalizado. Inicie sesión de nuevo con su contraseña temporal.",
  'Internal Service Failure - Cognito Unavailable': "Cognito no disponible",
  'Internal Service Failure - Unknown Failure': "Falla desconocida",
  'Must enter Reset Code': 'Debe introducir el código de reinicio',

  // Change Password Challenges
  set_password_challenge: 'Por motivos de seguridad, debe establecer una nueva contraseña la primera vez que inicie sesión.',
  reset_password_challenge: 'Hemos enviado un código de restablecimiento de contraseña a [EMAIL]. Introduzca ese código y una nueva contraseña.',
  set_new_password_challenge: 'La política de su empresa requiere que su contraseña caduque después de un tiempo. Hemos enviado un código de restablecimiento de contraseña a [EMAIL]. Introduzca ese código y una nueva contraseña.',
  change_your_password_challenge: 'Introduzca su contraseña actual y una nueva contraseña a continuación para cambiarla.',
  change_password_challenge: 'Introduzca una nueva contraseña para el usuario',
}

export const es_countries = {
  AF: 'Afganistán',
  AX: 'Islas Åland',
  AL: 'Albania',
  DZ: 'Argelia',
  AS: 'Samoa Americana',
  AD: 'Andorra',
  AO: 'Angola',
  AI: 'Anguila',
  AQ: 'Antártida',
  AG: 'Antigua y Barbuda',
  AR: 'Argentina',
  AM: 'Armenia',
  AW: 'Aruba',
  AU: 'Australia',
  AT: 'Austria',
  AZ: 'Azerbaiyán',
  BS: 'Bahamas',
  BH: 'Baréin',
  BD: 'Bangladés',
  BB: 'Barbados',
  BY: 'Bielorrusia',
  BE: 'Bélgica',
  BZ: 'Belice',
  BJ: 'Benín',
  BM: 'Bermudas',
  BT: 'Bután',
  BO: 'Bolivia (Estado Plurinacional de)',
  BQ: 'Bonaire, San Eustaquio y Saba',
  BA: 'Bosnia y Herzegovina',
  BW: 'Botsuana',
  BV: 'Isla Bouvet',
  BR: 'Brasil',
  IO: 'Territorio Británico del Océano Índico',
  BN: 'Brunéi',
  BG: 'Bulgaria',
  BF: 'Burkina Faso',
  BI: 'Burundi',
  CV: 'Cabo Verde',
  KH: 'Camboya',
  CM: 'Camerún',
  CA: 'Canadá',
  KY: 'Islas Caimán',
  CF: 'República Centroafricana',
  TD: 'Chad',
  CL: 'Chile',
  CN: 'China',
  CX: 'Isla de Navidad',
  CC: 'Islas Cocos (Keeling)',
  CO: 'Colombia',
  KM: 'Comoras',
  CG: 'Congo',
  CD: 'Congo, República Democrática del',
  CK: 'Islas Cook',
  CR: 'Costa Rica',
  CI: 'Costa de Marfil',
  HR: 'Croacia',
  CU: 'Cuba',
  CW: 'Curazao',
  CY: 'Chipre',
  CZ: 'República Checa',
  DK: 'Dinamarca',
  DJ: 'Yibuti',
  DM: 'Dominica',
  DO: 'República Dominicana',
  EC: 'Ecuador',
  EG: 'Egipto',
  SV: 'El Salvador',
  GQ: 'Guinea Ecuatorial',
  ER: 'Eritrea',
  EE: 'Estonia',
  SZ: 'Suazilandia',
  ET: 'Etiopía',
  FK: 'Islas Malvinas',
  FO: 'Islas Feroe',
  FJ: 'Fiyi',
  FI: 'Finlandia',
  FR: 'Francia',
  GF: 'Guayana Francesa',
  PF: 'Polinesia Francesa',
  TF: 'Territorios Australes Franceses',
  GA: 'Gabón',
  GM: 'Gambia',
  GE: 'Georgia',
  DE: 'Alemania',
  GH: 'Ghana',
  GI: 'Gibraltar',
  GR: 'Grecia',
  GL: 'Groenlandia',
  GD: 'Granada',
  GP: 'Guadalupe',
  GU: 'Guam',
  GT: 'Guatemala',
  GG: 'Guernsey',
  GN: 'Guinea',
  GW: 'Guinea-Bisáu',
  GY: 'Guyana',
  HT: 'Haití',
  HM: 'Isla Heard e Islas McDonald',
  VA: 'Santa Sede',
  HN: 'Honduras',
  HK: 'Hong Kong',
  HU: 'Hungría',
  IS: 'Islandia',
  IN: 'India',
  ID: 'Indonesia',
  IR: 'Irán (República Islámica de)',
  IQ: 'Irak',
  IE: 'Irlanda',
  IM: 'Isla de Man',
  IL: 'Israel',
  IT: 'Italia',
  JM: 'Jamaica',
  JP: 'Japón',
  JE: 'Jersey',
  JO: 'Jordania',
  KZ: 'Kazajistán',
  KE: 'Kenia',
  KI: 'Kiribati',
  KP: 'Corea (República Popular Democrática de)',
  KR: 'Corea, República de',
  KW: 'Kuwait',
  KG: 'Kirguistán',
  LA: 'República Democrática Popular Lao',
  LV: 'Letonia',
  LB: 'Líbano',
  LS: 'Lesoto',
  LR: 'Liberia',
  LY: 'Libia',
  LI: 'Liechtenstein',
  LT: 'Lituania',
  LU: 'Luxemburgo',
  MO: 'Macao',
  MG: 'Madagascar',
  MW: 'Malaui',
  MY: 'Malasia',
  MV: 'Maldivas',
  ML: 'Mali',
  MT: 'Malta',
  MH: 'Islas Marshall',
  MQ: 'Martinica',
  MR: 'Mauritania',
  MU: 'Mauricio',
  YT: 'Mayotte',
  MX: 'México',
  FM: 'Micronesia (Estados Federados de)',
  MD: 'Moldavia, República de',
  MC: 'Mónaco',
  MN: 'Mongolia',
  ME: 'Montenegro',
  MS: 'Montserrat',
  MA: 'Marruecos',
  MZ: 'Mozambique',
  MM: 'Birmania',
  NA: 'Namibia',
  NR: 'Nauru',
  NP: 'Nepal',
  NL: 'Países Bajos',
  NC: 'Nueva Caledonia',
  NZ: 'Nueva Zelanda',
  NI: 'Nicaragua',
  NE: 'Níger',
  NG: 'Nigeria',
  NU: 'Niue',
  NF: 'Isla de Norfolk',
  MK: 'Macedonia del Norte',
  MP: 'Islas Marianas del Norte',
  NO: 'Noruega',
  OM: 'Omán',
  PK: 'Pakistán',
  PW: 'Palaos',
  PS: 'Palestina, Estado de',
  PA: 'Panamá',
  PG: 'Papúa Nueva Guinea',
  PY: 'Paraguay',
  PE: 'Perú',
  PH: 'Filipinas',
  PN: 'Pitcairn',
  PL: 'Polonia',
  PT: 'Portugal',
  PR: 'Puerto Rico',
  QA: 'Catar',
  RE: 'Reunión',
  RO: 'Rumanía',
  RU: 'Federación de Rusia',
  RW: 'Ruanda',
  BL: 'San Bartolomé',
  SH: 'Santa Elena, Ascensión y Tristán da Acuña',
  KN: 'San Cristóbal y Nieves',
  LC: 'Santa Lucía',
  MF: 'San Martín (Francia)',
  PM: 'San Pedro y Miquelón',
  VC: 'San Vicente y las Granadinas',
  WS: 'Samoa',
  SM: 'San Marino',
  ST: 'Santo Tomé y Príncipe',
  SA: 'Arabia Saudí',
  SN: 'Senegal',
  RS: 'Serbia',
  SC: 'Seychelles',
  SL: 'Sierra Leona',
  SG: 'Singapur',
  SX: 'San Martín (Países Bajos)',
  SK: 'Eslovaquia',
  SI: 'Eslovenia',
  SB: 'Islas Salomón',
  SO: 'Somalia',
  ZA: 'Sudáfrica',
  GS: 'Islas Georgias del Sur y Sandwich del Sur',
  SS: 'Sudán del Sur',
  ES: 'España',
  LK: 'Sri Lanka',
  SD: 'Sudán',
  SR: 'Surinam',
  SJ: 'Svalbard y Jan Mayen',
  SE: 'Suecia',
  CH: 'Suiza',
  SY: 'República Árabe Siria',
  TW: 'Taiwán, provincia de China',
  TJ: 'Tayikistán',
  TZ: 'Tanzania, República Unida de',
  TH: 'Tailandia',
  TL: 'Timor Oriental',
  TG: 'Togo',
  TK: 'Tokelau',
  TO: 'Tonga',
  TT: 'Trinidad y Tobago',
  TN: 'Túnez',
  TR: 'Turquía',
  TM: 'Turkmenistán',
  TC: 'Islas Turcas y Caicos',
  TV: 'Tuvalu',
  UG: 'Uganda',
  UA: 'Ucrania',
  AE: 'Emiratos Árabes Unidos',
  GB: 'Reino Unido de Gran Bretaña e Irlanda del Norte',
  US: 'Estados Unidos de América',
  UM: 'Islas Ultramarinas Menores de los Estados Unidos',
  UY: 'Uruguay',
  UZ: 'Uzbekistán',
  VU: 'Vanuatu',
  VE: 'Venezuela (República Bolivariana de)',
  VN: 'Vietnam',
  VG: 'Islas Vírgenes Británicas',
  VI: 'Islas Vírgenes de los Estados Unidos',
  WF: 'Wallis y Futuna',
  EH: 'Sahara Occidental',
  YE: 'Yemen',
  ZM: 'Zambia',
  ZW: 'Zimbabue',
}
